import { getItemFromLocalStorage, setItemFromLocalStorage } from 'reactApp/appHelpers/localstorageHelpers';

const LOCAL_STORAGE_KEY = 'duplicates-promo-banner-hidden' as const;

export const getDuplicatesPromoBannerHidden = () => getItemFromLocalStorage(LOCAL_STORAGE_KEY);

export const setDuplicatesPromoBannerHidden = () => setItemFromLocalStorage(LOCAL_STORAGE_KEY, true);
